import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';
import styles from './styles';
import SignInForm from './components/SignInForm';
import CircularProgress from '@material-ui/core/CircularProgress';
import SignInPhoneForm from './components/SignInPhoneForm';
import Logo from './../../assets/images/Logo.png';
import {
  loginWithPassword,
  loginWithCode,
  resendEmailChangeLink,
} from 'store/login/loginOperations';
import { useDispatch } from 'react-redux';
import axios from 'axios'
import { useRedirectChecker } from 'hooks/useRedirectChecker';

const errorMessage = (e) => e.response?.data?.message || e.message;

const SignIn = ({ classes }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { redirectChecker } = useRedirectChecker()

  // const onSuccessfulSignIn = useCallback(async () => {
  //   navigate('/');
  // }, []);

  const [signInMethod, setSignInMethod] = useState('phone');
  const [loading, setLoading] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [error, setError] = useState();
  const [credentials, setCredentials] = useState();

  const onSignIn = useCallback(async ({ email, password }) => {
    setCredentials((prev) => ({ ...prev, email, password }));
    setLoading(true);
    setError();
    try {
      await dispatch(loginWithPassword(email, password, navigate));

    } catch (e) {
      console.log(e);
      setLoading(false);
      setError({
        reason: errorMessage(e),
        unconfirmed: e.response?.data?.type === 'email-not-confirmed',
      });
    }
  }, []);

  const onResend = useCallback(async () => {
    const { email, password } = credentials;
    try {
      await resendEmailChangeLink(email, password);
      return { text: `We sent a new link to ${email.trim()}.` };
    } catch (e) {
      return { text: errorMessage(e), failed: true };
    }
  }, [credentials]);

  const onPhoneSignIn = useCallback(
    async (values) => {
      // the code step unmounts the phone input, so keep the phone from the send-code step
      setCredentials((prev) => ({ ...prev, ...values }));
      setError();
      if (codeSent) {
        setLoading(true);
        try {
          await dispatch(loginWithCode(credentials.phone, values.secureCode, navigate));

        } catch (e) {
          setLoading(false);
          setError({ reason: errorMessage(e) });
        }
      } else {
        setLoading(true);
        try {
          const data = { phoneNumber: values.phone };
          await axios.post(
            `${process.env.REACT_APP_BASE_URL}/login/phone`,
            data
          );
          setCodeSent(true);
        } catch (e) {
          setLoading(false);
          console.error(e);
          setError({ error: errorMessage(e) });
        }
        setLoading(false);
      }
    },
    [codeSent, credentials]
  );

  const onToggleSignInMethod = useCallback(() => {
    setError();
    setSignInMethod((prevMethod) => (prevMethod === 'email' ? 'phone' : 'email'));
  }, []);

  useEffect(() => {
    redirectChecker()
  }, []);

  return (
    <div className={classes.background}>
      <Grid
        className={classes.root}
        container
        direction={'column'}
        alignItems={'center'}
        wrap={'nowrap'}
      >
        <Grid className={classes.logo}>
          <img src={Logo} alt="logo" className={classes.logoImg} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          container
          direction={'column'}
          justifyContent={'flex-end'}
          className={classes.titleWrapper}
        >
          <Grid item xs={'auto'}>
            <h1 className={classes.title}>
              Welcome to Motivity<span style={{ color: '#f58426' }}>360</span>
            </h1>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={5} container direction={'column'} justifyContent={'center'}>
          <Grid item xs={'auto'}>
            {loading ? (
              <div className={classes.loaderContainer}>
                <CircularProgress size={64} className={classes.loader} />
              </div>
            ) : signInMethod === 'email' ? (
              <SignInForm
                className={classes.form}
                error={error}
                value={credentials}
                onSubmit={onSignIn}
                onResend={onResend}
                setError={setError}
              />
            ) : (
              <SignInPhoneForm
                className={classes.form}
                codeSent={codeSent}
                value={credentials}
                error={error}
                onSubmit={onPhoneSignIn}
                setError={setError}
              />
            )}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          container
          direction={'column'}
          justifyContent={'flex-start'}
          alignItems={'center'}
        >
          <Grid item xs={'auto'}>
            <div className={classes.footer}>
              <button className={classes.link} onClick={onToggleSignInMethod}>
                <span className={classes.label}>Or</span>
                {signInMethod === 'email'
                  ? 'Sign In with Phone Number'
                  : 'Sign In with Email And Password'}
              </button>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(SignIn);
